<script setup>
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue'
import Xicon from "@/Components/Icons/Xicon.vue";
import Button from "@/Components/Button.vue";

const props = defineProps({
    modelValue: Boolean,
    heading: String,
    description: String,
    buttonName: {
        type: String,
        default: 'Delete'
    },
    isCancel: {
        type: Boolean,
        default: true
    },
    isButton: {
        type: Boolean,
        default: true
    },
    overflowHidden: {
        type: Boolean,
        default: false
    },
    CustomClass: {
        type: String,
        default: 'w-full max-w-lg'
    },
    showCancelButton: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['update:modelValue', 'confirm']);

</script>

<template>

    <TransitionRoot appear :show="modelValue" as="template">
        <Dialog as="div" @close="emit('update:modelValue',false)" class="relative z-50">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black bg-opacity-25"/>
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center"
                >
                    <TransitionChild
                        as="template"
                        enter="duration-300 ease-out"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="duration-200 ease-in"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <DialogPanel
                            class=" transform rounded-sm bg-white text-left align-middle shadow-xl transition-all"
                            :class="`${overflowHidden&&'overflow-hidden'} ${CustomClass}`">

                            <slot name="header">
                                <DialogTitle as="h3"
                                             class="text-lg leading-6 font-medium text-gray-900 flex justify-between p-6">
                                    <div>
                                        {{ heading }}
                                    </div>
                                    <div>
                                        <Xicon @click="emit('update:modelValue',false)"
                                               class="h-5 w-5 text-primary-light cursor-pointer hover:text-gray-600 ease-in-out"/>
                                    </div>
                                </DialogTitle>
                            </slot>
                            <div class="p-6 pt-0">

                                <div class="mt-2">
                                    {{ description }}
                                    <slot></slot>
                                </div>
                            </div>

                            <slot name="footer">
                                <div class="bg-gray-50 px-4 py-3 sm:px-6 flex sm:flex-row-reverse pt-3 gap-4">
                                    <div v-if="isButton">
                                        <Button type="submit" @click="emit('confirm')">
                                            {{ buttonName }}
                                        </Button>
                                    </div>
                                    <div v-if="showCancelButton">
                                        <Button
                                            class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white "
                                            v-if="isCancel"
                                            type="button"
                                            @click="emit('update:modelValue',false)">
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </slot>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
